import classNames from 'classnames'

const TextButton = ({ children, className, onClick }) => {
    const btnClass = classNames('indigo-text-btn', className)

    return (
        <button type="button" className={btnClass} onClick={onClick}>
            <span>{children}</span>
        </button>
    )
}
TextButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
}

export default TextButton
